import React, { useEffect, useState } from 'react';
import PostMessageService, {
} from '../../services/PostMessage';

import {
  CancelContainer,
  CancelImage,
  CancelImageSection,
  CancelSubtitleText,
  CancelTextSection,
  CancelTitle,
} from './CancelStyledComponents';
import CancelImg from '../../assets/images/cancel/cancel.png';
import {
  MainButton,
  MainLink,
  TextMedium,
} from '../../styles/GlobalStyledComponents';
import ViewModeService from '../../services/ViewMode/index';
import CustomerDeviceService from '../../services/CustomerDevice';
import { useMerchant } from '../../contexts/MerchantContext';
import { useCreditProposalResult } from '../../contexts/CreditProposalResultContext';

interface CancelProps {
  loadingEvent: (data: boolean) => void;
}

export const Cancel: React.FC<CancelProps> = ({ loadingEvent }) => {
  const { isPostDataMessages } = useMerchant();
  const { creditProposalResult } = useCreditProposalResult();

  const [isApp, setisApp] = useState<boolean>(false);
  const [device, setDevice] = useState<string | null>(null);

  const handleReturn = async () => {
    if (CustomerDeviceService.getCustomerDevice()) {
      window.location.href = 'https://pepperfinance.es/';
    } else {
      if (isApp && device === 'android') {
        window.location.href = 'peppermerchants://home';
      } else {
        PostMessageService.closeCEX();
      }
    }
  };

  useEffect(() => {
    loadingEvent(false);
    if (isPostDataMessages && creditProposalResult) {
      PostMessageService.FinancingCanceled(
        creditProposalResult.credit_proposal_id,
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setisApp(ViewModeService.getViewMode() === 'APP' ? true : false);
    setDevice(ViewModeService.getDevice());
  }, [isApp, device]);

  return (
    <>
      <CancelContainer id="cancel-container">
        <CancelTextSection id="cancel-text-section">
          <CancelTitle id="cancel-title" $align="left">
            ¡Entendido! Aunque no se haya guardado la propuesta alternativa,
            podrás retomarla cuando quieras y finalizarla fácilmente a partir de la propuesta original.
          </CancelTitle>
          <CancelSubtitleText id="cancel-subtitle" $align="left">
            Si necesitas ayuda, llama a tu comercial al móvil o al{' '}
            <TextMedium $fontSize={18}>91 216 12 12</TextMedium>
          </CancelSubtitleText>
        </CancelTextSection>
        <CancelImageSection id="cancel-image-section">
          <CancelImage src={CancelImg} alt="Proceso cancelado" />
        </CancelImageSection>
      </CancelContainer>
      <MainButton id="cancel-return-btn" onClick={handleReturn}>
        Cerrar
      </MainButton>
    </>
  );
};
